import styled from "styled-components";

export const ChatInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
`;

/* 📍 主输入框：只有 SendMessage 在内部 */
export const ChatInputContainer = styled.form`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  background: var(--cl-panel);
  border: 1px solid var(--cl-border);
  border-radius: 26px;
  padding: 6px 6px 6px 16px;
  box-shadow: 0 4px 20px rgba(42, 39, 35, 0.05);
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);

  &:focus-within {
    border-color: var(--cl-border-strong);
    box-shadow: 0 8px 30px rgba(42, 39, 35, 0.08);
  }
`;

/* 📍 改为 styled.textarea 支持 Shift+Enter 换行 */
export const ChatMessage = styled.textarea`
  all: unset;
  flex: 1;
  min-width: 0;
  min-height: 24px;
  max-height: 160px;
  padding: 6px 0;
  font-weight: 400;
  font-size: 15px;
  line-height: 1.5;
  font-family: var(--cl-font-sans);
  color: var(--cl-text);
  box-sizing: border-box;
  resize: none;
  overflow-y: auto;
  word-break: break-word;

  ::placeholder {
    color: var(--cl-text-faint);
    font-weight: 400;
    font-size: 15px;
  }
`;

export const SendMessage = styled.button`
  all: unset;
  cursor: pointer;
  flex: none;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: transparent;
  color: var(--cl-text-muted);
  box-sizing: border-box;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  margin-bottom: 2px;

  &:hover {
    background: var(--cl-accent);
    color: #ffffff;
    box-shadow: 0 4px 12px rgba(218, 119, 86, 0.3);
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
    background: var(--cl-accent-press);
  }
`;
